<template>
  <div class="user-table-container">
    <table class="user-table">
      <thead>
      <tr>
        <thUser rowspan="3" sort-prop="name" :title="$t('vue2.assign_users_hours.name')" :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <th :colspan="numberOfCols" class="working-hours">
          <div>{{ $t('vue2.assign_users_hours.work_hours') }}</div>
        </th>
        <th colspan="1" class="rest-hours" v-if="isPoolsDeactivated">Rest</th>
        <th :colspan="numberOfCols" class="teaching-hours">
          <div>{{ $t('vue2.assign_users_hours.teaching') }}</div>
        </th>
        <th :colspan="numberOfCols" class="task-hours" v-if="isSchoolYearWithNewEmploymentDeal">
          <div>{{ $t('vue2.assign_users_hours.tasks') }}</div>
        </th>
        <th :colspan="numberOfCols" class="prep-hours" v-if="isSchoolYearWithNewEmploymentDeal">
          {{ $t('vue2.assign_users_hours.preparation') }}
        </th>
        <th :colspan="numberOfCols" class="prep-hours" v-if="isLocalPoolActivated">
          Lokalpulje
        </th>
        <th colspan="1" class="absence-hours">{{ $t('vue2.assign_users_hours.absence') }}</th>
        <th :colspan="numberOfCols" class="sub-hours">{{ $t('vue2.assign_users_hours.substitute_hours') }}</th>
        <th :colspan="numberOfCols" class="club-hours" v-if="isSFOActive">
          <div>{{ $t('vue2.task_overview.club') }}</div>
        </th>
      </tr>
      <tr>
        <!-- ARBEJDSTID -->
        <thUser sort-prop="assigned_total_hours" v-if="viewSettings.show_assigned.active"
                :title="$t('vue2.assign_users_hours.assigned')"
                :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <thUser sort-prop="actual_total_hours" :title="$t('vue2.assign_users_hours.scheduled')" :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <thUser sort-prop="diff_total_hours" v-if="viewSettings.show_assigned.active"
                :title="$t('vue2.assign_users_hours.diff')" :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <!-- REST -->
        <thUser sort-prop="rest_hours"
                title="Rest"
                v-if="isPoolsDeactivated"
                :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <!-- UNDERVISNING -->
        <thUser sort-prop="assigned_teaching_hours" v-if="viewSettings.show_assigned.active"
                :title="$t('vue2.assign_users_hours.assigned')"
                :activeSortKey="sortKey" @sortby="sortBy"></thUser>
        <thUser sort-prop="actual_teaching_hours" :title="$t('vue2.assign_users_hours.scheduled')"
                :activeSortKey="sortKey" @sortby="sortBy"></thUser>
        <thUser sort-prop="diff_teaching_hours" v-if="viewSettings.show_assigned.active"
                :title="$t('vue2.assign_users_hours.diff')" :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <!-- ØVRIGE OPGAVER -->
        <template v-if="isSchoolYearWithNewEmploymentDeal">
          <thUser sort-prop="assigned_additional_task_hours" v-if="viewSettings.show_assigned.active"
                  :title="$t('vue2.assign_users_hours.assigned')"
                  :activeSortKey="sortKey" @sortby="sortBy"></thUser>
          <thUser sort-prop="actual_additional_task_hours" :title="$t('vue2.assign_users_hours.scheduled')"
                  :activeSortKey="sortKey" @sortby="sortBy"></thUser>
          <thUser sort-prop="diff_additional_task_hours" v-if="viewSettings.show_assigned.active"
                  :title="$t('vue2.assign_users_hours.diff')"
                  :activeSortKey="sortKey"
                  @sortby="sortBy"></thUser>
        </template>
        <!-- FORBEREDELSE -->
        <template v-if="isSchoolYearWithNewEmploymentDeal">
          <thUser sort-prop="assigned_preparation_hours" v-if="viewSettings.show_assigned.active"
                  :title="$t('vue2.assign_users_hours.assigned')"
                  :activeSortKey="sortKey" @sortby="sortBy"></thUser>
          <thUser sort-prop="actual_preparation_hours" :title="$t('vue2.assign_users_hours.scheduled')"
                  :activeSortKey="sortKey" @sortby="sortBy"></thUser>
          <thUser sort-prop="diff_preparation_hours" v-if="viewSettings.show_assigned.active"
                  :title="$t('vue2.assign_users_hours.diff')"
                  :activeSortKey="sortKey"
                  @sortby="sortBy"></thUser>
        </template>
        <!-- LOKALPULJE -->
        <template v-if="isLocalPoolActivated">
          <thUser sort-prop="assigned_pool_hours" v-if="viewSettings.show_assigned.active"
                  :title="$t('vue2.assign_users_hours.assigned')"
                  :activeSortKey="sortKey" @sortby="sortBy"></thUser>
          <thUser sort-prop="actual_pool_hours" :title="$t('vue2.assign_users_hours.scheduled')"
                  :activeSortKey="sortKey" @sortby="sortBy"></thUser>
          <thUser sort-prop="diff_pool_hours" v-if="viewSettings.show_assigned.active"
                  :title="$t('vue2.assign_users_hours.diff')"
                  :activeSortKey="sortKey"
                  @sortby="sortBy"></thUser>
        </template>
        <!-- FRAVÆR -->
        <thUser sort-prop="actual_absence_hours" :title="$t('vue2.assign_users_hours.scheduled')"
                :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <!-- VIKATIMER -->
        <thUser sort-prop="substitute_pool_hours" v-if="viewSettings.show_assigned.active"
                :title="$t('vue2.assign_users_hours.assigned')"
                :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <thUser sort-prop="actual_substitute_hours" :title="$t('vue2.assign_users_hours.scheduled')"
                :activeSortKey="sortKey" @sortby="sortBy"></thUser>
        <thUser sort-prop="diff_substitute_hours" v-if="viewSettings.show_assigned.active"
                :title="$t('vue2.assign_users_hours.diff')" :activeSortKey="sortKey"
                @sortby="sortBy"></thUser>
        <!-- CLUB -->
        <template v-if="isSFOActive">
          <thUser sort-prop="assigned_club_hours" v-if="viewSettings.show_assigned.active"
                  :title="$t('vue2.assign_users_hours.assigned')"
                  :activeSortKey="sortKey" @sortby="sortBy"></thUser>
          <thUser sort-prop="actual_club_hours" :title="$t('vue2.assign_users_hours.scheduled')"
                  :activeSortKey="sortKey" @sortby="sortBy"></thUser>
          <thUser sort-prop="diff_club_hours" v-if="viewSettings.show_assigned.active"
                  :title="$t('vue2.assign_users_hours.diff')"
                  :activeSortKey="sortKey"
                  @sortby="sortBy"></thUser>
        </template>
      </tr>
      </thead>
      <tbody class="user-table__body">
      <trUser
        v-for="user in filteredData"
        :key="user.id"
        :theUserCanManageAssignedHours="theUserCanManageAssignedHours"
        :schoolid="schoolid"
        :user="user"
        :isSFOActive="isSFOActive"
        :isLocalPoolActivated="isLocalPoolActivated"
        :isSchoolYearWithNewEmploymentDeal="isSchoolYearWithNewEmploymentDeal"
        :activeSchoolYear="activeSchoolYear"
        :isDatesPristine="isDatesPristine"
        :numberOfWorkDays="numberOfWorkDays"
        :numberOfWorkDaysInPeriod="numberOfWorkDaysInPeriod"
        :locale="locale"
        :viewSettings="viewSettings"
        :isPoolsDeactivated="isPoolsDeactivated"
        :prepFactor="prepFactor"
        @openEdit="setOpenEdit"
        @setTheUserToShowTasks="setTheUserToShowTasks"
        @setActiveUser="setActiveUser">
      </trUser>
      </tbody>
    </table>
    <div class="popper_child" ref="popper_child" v-if="theEditNumberUserId">
      <transition name="scale">
        <div class="number__input-opened" v-if="isDropdownPopperDone">
          <input type="number"
                 v-model.lazy="theEditNumberNumber"
                 v-focus
                 v-on-clickaway="closeEditing"
                 @keyup.enter="doneEditing"/>
          <button class="bttn bttn--primary" :class="{'bttn--small--loading': isUpdatingNumber}"
                  @click.stop="doneEditing">
            <span v-if="!isUpdatingNumber">{{ $t('vue2.common.save') }}</span>
          </button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import thUser from './AssignHoursAllUsersTheadTh'
import trUser from './AssingHoursAllUsersUserPerf'
import moment from 'moment'
import {createPopper} from '@popperjs/core' // eslint-disable-line no-unused-vars
import {mixin as clickaway} from 'vue-clickaway'
import docendo from '../../docendo'
import Loader from '../common/Loader'
import eventbus from '../../eventbus'

export default {
  mixins: [clickaway],
  components: {Loader, thUser, trUser},
  props: {
    theUserCanManageAssignedHours: {
      default: false
    },
    schoolid: {},
    users: {
      type: Array,
      default: []
    },
    isDatesPristine: {
      type: Boolean,
      default: true
    },
    isLocalPoolActivated: {
      type: Boolean,
      default: false
    },
    numberOfWorkDaysInPeriod: {
      required: true
    },
    numberOfWorkDays: {
      required: true
    },
    locale: {
      default: 'en'
    },
    viewSettings: {
      type: Object
    },
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    },
    prepFactor: {
      default: null
    }
  },
  data () {
    return {
      sortKey: 'name',
      sortOrder: 1,
      theEditNumberUserId: null,
      theEditNumberType: '',
      theEditNumberNumber: 0,
      isDropdownPopperDone: false,
      isUpdatingNumber: false
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
        el.select()
      }
    }
  },
  computed: {
    numberOfCols () {
      const isShowAssignedActivated = this.viewSettings['show_assigned']['active']
      return isShowAssignedActivated ? 3 : 1
    },
    isSFOActive () {
      return this.$store.getters.isSchoolSFOActive
    },
    filteredData () {
      var sortKey = this.sortKey
      var order = this.sortOrder
      var data = this.users
      if (sortKey && sortKey !== 'name') {
        data = data.sort((a, b) => {
          a = a[sortKey]
          b = b[sortKey]
          if (order < 0) {
            return a - b
          } else {
            return b - a
          }
        })
      } else {
        return this.$helpers.sortArrOnName(data)
      }
      return data
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    isSchoolYearWithNewEmploymentDeal () {
      return moment(this.$store.state.localActivatedSchoolYear.employee_time_start).isAfter('2021-01-01') || moment(this.$store.state.localActivatedSchoolYear.student_time_start).isAfter('2021-01-01')
    }
  },
  methods: {
    createPopper (parentPopper, childPopper) {
      parentPopper.appendChild(childPopper)
    },
    setOpenEdit (obj) {
      this.isDropdownPopperDone = false
      this.theEditNumberUserId = obj.userId
      this.theEditNumberType = obj.type
      this.theEditNumberNumber = obj.number
      this.$nextTick(_ => {
        this.createPopper(obj.evt.target, this.$refs.popper_child)
        this.isDropdownPopperDone = true
      })
    },
    sortBy (key) {
      this.sortKey = key
      this.sortOrder = this.sortOrder * -1
    },
    updatedUser (user) {
      this.$emit('updatedUser', user)
    },
    setActiveUser (userAndFilter) {
      this.$emit('setActiveUser', userAndFilter)
    },
    setTheUserToShowTasks (user) {
      this.$emit('setTheUserToShowTasks', user)
    },
    closeEditing () {
      this.isDropdownPopperDone = false
      this.theEditNumberUserId = null
      this.theEditNumberType = ''
      this.theEditNumberNumber = 0
    },
    doneEditing () {
      this.docendoEditHours()
    },
    docendoEditHours () {
      this.isUpdatingNumber = true
      const key = this.theEditNumberType
      let updateVal = {[key]: this.theEditNumberNumber}
      const updatePrepWithPrepFactor = this.prepFactor && this.theEditNumberType === 'assigned_teaching_hours'
      if (updatePrepWithPrepFactor) {
        console.log('uv: ', this.theEditNumberNumber + ' = ' + this.theEditNumberNumber * this.prepFactor + ' i forberedelsestid')
        const thePrep = this.theEditNumberNumber * this.prepFactor
        updateVal = {
          assigned_teaching_hours: this.theEditNumberNumber,
          assigned_preparation_hours: thePrep
        }
      }
      docendo.schoolUserYearUpdate(this.schoolid, this.theEditNumberUserId, this.activeSchoolYear.name, updateVal,
        success => {
          if (updatePrepWithPrepFactor) {
            const thePrep = this.theEditNumberNumber * this.prepFactor
            eventbus.toast = {text: 'Gemt & automatisk opdateret forberedelsestid til ' + thePrep + ' timer', 'success': true}
          }
          this.isUpdatingNumber = false
          this.closeEditing()
          this.$emit('updatedUser', success)
        })
    }
  },
  beforeDestroy () {
    if (this.$refs.popper_child) {
      this.$refs.popper_child.remove()
    }
  }
}
</script>


<style scoped>
@import '../../assets/css/variables.css';

.user-table-container {
  max-width: 100%;
  max-height: calc(100vh - 190px);
  overflow: scroll;
  position: relative;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgb(0 0 0 / 7%);
  background: #fff;
}

.user-table {
  width: 100%;
  color: #3d4340;
  border-collapse: inherit;
  border-spacing: 0;
}

.user-table th {
  color: #3d4340;
  font-weight: bold;
  position: sticky;
  z-index: 1;
  top: 0;
}

.user-table thead tr:first-child th:first-child {
  padding-left: 20px;
  cursor: pointer;
}

.user-table tbody tr:nth-child(odd) {
  background-color: #f8fafb;
}

.user-table tbody tr td {
  padding: 0 18px;
  border-top: 1px solid #ffffff;
  border-bottom: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  text-align: center;
}

.user-table thead tr:first-child th:first-child,
.user-table tbody tr td:first-child {
  text-align: left;
  width: 200px;
}

.user-table th {
  border-collapse: collapse;
  border-bottom: 1px solid #d8d8d8;
  border-right: 1px solid #d8d8d8;
  padding: 4px;
  text-align: center;
}


.user-table tr:first-child th:nth-child(1) {
  border-right: none;
}

.user-table tr:first-child th:nth-child(2),
.user-table tr:nth-child(2) th:nth-child(1) {
  border-left: 1px solid #d8d8d8;
}

.working-hours,
.assigned_total_hours,
.actual_total_hours,
.diff_total_hours {
  background: #f6f9fe;
}

.teaching-hours,
.assigned_teaching_hours,
.actual_teaching_hours,
.diff_teaching_hours {
  background: #f2f2ff;
}

.task-hours,
.assigned_additional_task_hours,
.actual_additional_task_hours,
.diff_additional_task_hours {
  background: #fffbf1;
}

.prep-hours,
.assigned_preparation_hours,
.actual_preparation_hours,
.diff_preparation_hours,
.assigned_pool_hours,
.actual_pool_hours,
.diff_pool_hours {
  background: #fefefe;
}

.absence-hours,
.actual_absence_hours {
  background: #f7f6f6;
}

.sub-hours,
.substitute_pool_hours,
.actual_substitute_hours,
.diff_substitute_hours {
  background: #f1fafb;
}

.club-hours,
.assigned_club_hours,
.actual_club_hours,
.diff_club_hours {
  background: #fef7f4;
}

.number__input-opened {
  position: absolute;
  top: 10%;
  left: 10%;
  display: flex;
  align-items: stretch;
  z-index: 1;
  background: #ffffff;
  padding: 0;
  box-shadow: 0 1px 3px 0 rgb(27 36 50 / 15%);
}

.number__input-opened input {
  width: 100px !important;
  border-radius: 4px 0 0 4px;
}

.number__input-opened button {
  height: auto;
  border-radius: 0 4px 4px 0;
  width: 65px !important;
}

.scale-enter-active {
  transition: transform 0.15s;
}

.scale-enter, .scale-leave-to {
  transform: scale(0.5);
}

.bttn.bttn--primary.bttn--primary--spinner {
  background-color: #edf0f5 !important;
}

.rest-hours,
.rest_hours {
  background: #fff;
}

</style>



// WEBPACK FOOTER //
// AssignHoursAllUsers.vue?462ea70c